export default {
    consent_page_title: "Kevi | Authorize support agent",
    consent_title: "Authorize support agent",
    consent_logged_in_as: "Signed in as <strong>{0}</strong>.",
    consent_question: "Allow WhatsApp <strong>{0}</strong> to read data from account <strong>{1}</strong>?",
    consent_confirm: "Authorize",
    consent_success_title: "Authorization completed",
    consent_success_subtitle: "The support agent can now read this account data for this WhatsApp number.",
    consent_invalid_title: "Invalid or expired link",
    consent_invalid_subtitle: "Request a new authorization link from support.",
    consent_missing_request: "Incomplete authorization link.",
    consent_confirm_error: "Could not complete authorization. Please try again.",
    manage_page_title: "Kevi | Agent authorizations",
    manage_title: "Support agent authorizations",
    manage_description: "WhatsApp numbers authorized to read this account data via the support agent.",
    manage_empty_title: "No authorizations yet",
    manage_empty: "No active authorizations for support agents.",
    manage_address: "Address",
    manage_authorizer: "Authorized by",
    manage_last_used: "Last used",
    manage_actions: "Actions",
    manage_revoke: "Revoke",
    manage_revoke_confirm: "Revoke this authorization? The agent will no longer read this account for this WhatsApp.",
    manage_revoke_success: "Authorization revoked successfully.",
    manage_revoke_error: "Could not revoke authorization.",
};
